(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-recomendations"] && !Shopify.designMode) return;
  try {
    const update_cart_quantity = (quantity) => {
    let cartQuantity = document.querySelector('.cart-count-bubble > span');
    let cartMessage = document.querySelector('.cart-message');

    if (!cartQuantity) {
      let svg_wrapper = document.querySelector('#cart-icon-bubble > .svg-wrapper');

      let cartQuantityElement = `
        <div class="cart-count-bubble">
          <span aria-hidden="true">1</span>
          <span class="visually-hidden">1 item</span>
        </div>
      `;

      svg_wrapper.insertAdjacentHTML('beforeend', cartQuantityElement);
    }

    if (cartQuantity) {
      cartQuantity.innerText = parseInt(cartQuantity.innerText) + quantity;
    }

    if (cartMessage) {
      cartMessage.innerHTML = '*Adicionado ao carrinho! <a href="/cart">Ver carrinho</a>';
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cart-button[data-product-id]').forEach((button) => {
      button.addEventListener('click', function () {
        const productId = this.getAttribute('data-product-id');
        const icon = this.querySelector('i');
        const spinner = this.querySelector('.loading__spinner');

        icon.style.display = 'none';
        spinner.classList.remove('hidden');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: productId,
                quantity: 1,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            icon.style.display = 'flex';
            spinner.classList.add('hidden');
            update_cart_quantity(1);
          })
          .catch((error) => console.error('Error:', error));
      });
    });

    document.querySelector('.add-all-button')?.addEventListener('click', function () {
      const productItems = document.querySelectorAll('.cart-button[data-product-id]');
      let btn_text = this.querySelector('.button__text');
      let btn_load = this.querySelector('.loading__spinner');

      btn_text.innerText = '';
      btn_load.classList.remove('hidden');

      const items = Array.from(productItems).map((button) => ({
        id: button.getAttribute('data-product-id'),
        quantity: 1,
      }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => response.json())
        .then((data) => {
          update_cart_quantity(data.items.length);
          btn_text.innerText = 'Adicionar tudo ao carrinho novamente';
          btn_load.classList.add('hidden');
        })
        .catch((error) => console.error('Error:', error));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const modalHTML = `
    <div id="video-modal" class="video-modal">
        <div class="video-modal-content">
            <span class="video-modal-close"><i class="ph ph-x-circle"></i></span>
            <div id="video-modal-body"></div>
        </div>
    </div>
`;
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const items = document.querySelectorAll('.video-item');
    const modal = document.getElementById('video-modal');
    const modalBody = document.getElementById('video-modal-body');
    const closeBtn = document.querySelector('.video-modal-close');

    items.forEach((item, index) => {
      item.addEventListener('click', () => {
        const videoElement = item.querySelector('video, iframe');
        if (!videoElement) return;

        const clone = videoElement.cloneNode(true);
        if (clone.tagName.toLowerCase() === 'video') {
          clone.removeAttribute('muted');
          clone.setAttribute('controls', 'true');
          clone.setAttribute('disablePictureInPicture', 'true');
          clone.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
          clone.setAttribute('autoplay', 'true');
        }

        modalBody.innerHTML = '';
        modalBody.appendChild(clone);
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    });

    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
      modalBody.innerHTML = '';
      document.body.style.overflow = 'auto';
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
        modalBody.innerHTML = '';
        document.body.style.overflow = 'auto';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        modal.style.display = 'none';
        modalBody.innerHTML = '';
        document.body.style.overflow = 'auto';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
